import PropTypes from "prop-types";
import React from 'react'
import TextScramble from '../components/TextScramble'

export default function DecryptTitle({data, className, breakRule, spaceAfter }) {
  const { contentfulPaginas } = data
  const { decrypt, titulo } = contentfulPaginas
  
  if (decrypt === true ) {
    const { posicionamento, textoNormal, textoDecrypt } = contentfulPaginas.tituloDecrypt

    if (posicionamento === false ) {
      return (
        <h1 className={className}>
          { !breakRule 
            ? <span className={`mr-${spaceAfter}`}>{textoNormal}</span> 
            : <>{textoNormal}<br className="lg:block hidden"/></>
          }
            <TextScramble>
              {textoDecrypt}
            </TextScramble>
        </h1>
      )
    } else {
      return (
        <h1 className={className}>
          <TextScramble>
            {textoDecrypt}
          </TextScramble>
          { !breakRule 
            ? <span className={`ml-${spaceAfter}`}>{textoNormal}</span> 
            : <><br className="lg:block hidden"/>{textoNormal}</> 
          }
        </h1>
      )
    }

  } else {
  

    return  <h1 className={className}>{titulo}</h1>
  
  }
}

DecryptTitle.propTypes = {
  breakRule: PropTypes.element,
  className: PropTypes.string,
  data: PropTypes.any.isRequired,
  spaceAfter: PropTypes.number
}
